import React from "react";
import { DisplayDiscussionForMiniScreenProvider } from "../contexts/DisplayDiscussionForMiniScreenContext";
import Navbar from "../components/Navbar";
import { AuthProvider } from "../contexts/AuthContext";
import { ThemeProvider } from "../contexts/ThemeContext";

export default function ReunionSquelette({ children }) {
  return (
    <DisplayDiscussionForMiniScreenProvider>
      <Navbar />
      <AuthProvider>
        <ThemeProvider>
          <div className="mon-composant-meet-video-main-container">
            {children}
          </div>
        </ThemeProvider>
      </AuthProvider>
    </DisplayDiscussionForMiniScreenProvider>
  );
}
